import { CartaoCadastroItem } from './cartao-cadastro-item';
import { ColaboradoresId } from './colaborador-ids';

export class CartaoCadastroLote {
    contratos: CartaoCadastroItem[];
    colaboradores: ColaboradoresId[];
    grupoGuid: string;

    constructor(contratos: CartaoCadastroItem[], colaboradores: ColaboradoresId[], grupoGuid: string) {
        this.contratos = contratos;
        this.colaboradores = colaboradores;
        this.grupoGuid = grupoGuid;
    }
}

